






























































































































































































































































































import { Mixins, Component } from 'vue-mixin-decorator';
import { Watch } from 'vue-property-decorator';
import BaseCarousel from '@/components/BaseCarousel.vue';
import StepCard from '@/components/StepCard.vue';
import CardOverlay from '@/components/CardOverlay.vue';
import LuanchGameMixin from '@/mixins/luanchGameMixin';
import AuthConnector from '@/connector/Auth.vue';
import DialogConnector from '@/connector/Dialog.vue';

@Component({
  components: {
    BaseCarousel,
    CardOverlay,
    StepCard,
    AuthConnector,
    DialogConnector,
  },
})
export default class HomePage extends Mixins<LuanchGameMixin>(LuanchGameMixin) {
  public topgameDisplay: { text: string; video: string; title: string; studio: string } = {
    text: '',
    video: '',
    title: '',
    studio: '',
  };

  // eslint-disable-next-line class-methods-use-this
  displayItemDetail(value: string) {
    const contents: {
      // eslint-disable-next-line max-len
      [key: string]: { text: string; video: string; title: string; studio: string; imagePath: string };
    } = {
      moneytrain2: {
        title: 'Money Train 2',
        text: 'Money Train 2 สล็อตค่าย relax gaming ชื่อไทยคือ เกมมันนี่เทรน2 มีการชนะที่มีรางวัลในการชนะมากถึง 50,000 เท่า โดยฟรีเกมสามารถซื้อได้และมีอยู่ถึงสองรูปแบบเมื่อรีลสปินเต็มไปด้วยลัญลักษณ์จะมีการเพิ่มคอลัมน์และจะเพิ่มจำนวนอีกครั้งให้ครบ 3 อยู่เสมอภายในฟรีเกมก็จะมีปืนต่าง ๆ เพื่อช่วยทำให้ตัวคูณมากยิ่งขึ้นไปเลยๆ  โดยจำนวนตัวคูณจะอยู่ที่ลัญลักษณ์กับจำนวนเงินที่เล่นของรอบในแต่ละครั้ง',
        video: 'https://s3.ap-southeast-1.amazonaws.com/asset.betflix8k.com/Copy+of+Money+Train+2+-+Google+Chrome+2564-07-16+16-33-52.mp4',
        studio: 'relax gaming',
        imagePath: '/games/moneytrain2.jpg',
      },
      thor: {
        title: 'Thor Infinity Reels',
        text: 'Thor Infinity Reels เป็นวิดีโอสล็อตจากนักพัฒนาเกม ReelPlay ที่มีระบบเกม Infinity Reels แบบไดนามิก ดูวงล้อจะขยายความยาวอย่างต่อเนื่องทุกครั้งที่คุณเพิ่มการเชื่อมต่อสัญลักษณ์ที่ชนะซึ่งเมื่อถึง 12 วงล้อในการเล่นคุณจะได้รับแจ็คพอตคงที่เท่ากับ 888x',
        video: 'https://s3.ap-southeast-1.amazonaws.com/asset.betflix8k.com/Copy+of+Thor+Infinity+Reels+-+Google+Chrome+2564-07-16+16-43-09.mp4',
        studio: 'pg slot',
        imagePath: '/games/thor.jpg',
      },
      vikings: {
        text: 'Vikings Unleashed Megaways ถือเป็นเกมได้เงินจริง ยอดนิยมที่สามารถเข้าเล่นได้บนมือถือ หรือ คอมพิวเตอร์ โดยคำถามยอดนิยมจากสมาชิกในปี 2020 มักถามว่า สล็อตไวกิ้ง ค่ายไหน ดีที่สุด หรือ เปิดให้บริการอยู่ที่ค่ายไหน ซึ่งสำหรับ Vikings Unleashed เปิดให้บริการเข้าเล่นอยู่ที่ค่าย Blueprint Gaming',
        video: 'https://s3.ap-southeast-1.amazonaws.com/asset.betflix8k.com/Copy+of+Vikings+Unleashed+-+Google+Chrome+2564-07-13+00-32-06.mp4',
        title: 'Vikings Unleashed Megaways',
        studio: 'blueprint gaming',
        imagePath: '/games/vikings.jpg',
      },
      deadwood: {
        text: 'wild west gold เกมสล็อตนายอำเภอ ไวด์เวสโกล จากค่าย Pragmatic Play ค่ายเกมสล็อตชื่อดัง ที่ได้รับความนิยมเป็นอย่างมาก มีผู้เล่นให้ความสนใจสูง เพราะเป็น เกมสล็อตแตกง่าย ฟรีเจอร์โบนัสดี และตัวคูณสูง ทำให้ผู้เล่นได้รับเงินรางวัลเพิ่มขึ้นอย่างมหาศาล ผู้เล่นทุกท่านสามารถเข้า ทดลองเล่นสล็อต Wild west gold ได้ที่เว็บไซต์ของเรา',
        video: 'https://s3.ap-southeast-1.amazonaws.com/asset.betflix8k.com/Copy+of+Wild+West+Gold+-+Google+Chrome+2564-07-16+16-19-56.mp4',
        title: 'wild west gold',
        studio: 'pragmatic play',
        imagePath: '/games/deadwood.jpg',
      },
      ironbank: {
        text: 'Caishen Wins เทพเจ้าแห่งความร่ำรวยจะนำพาทุกท่านไปลุ้นรับเงินรางวัลแจ๊คพอตมากมาย พร้อมลุ้นรับ PG slot เครดิตฟรี มากมายจากเกมสล็อตออนไลน์ Caishen Wins ที่มีฟีเจอร์ต่างๆมากมายให้ลุ้นกันได้ไม่มีเบื่อ พร้อมทั้งอัตราการจ่ายเงินรางวัลสูงสุดถึง X80 สามารถลุ้นรับเงินรางวัลก้อนโตได้ง่ายๆ ไม่ยุ่งยาก เทพเจ้าแห่งความร่ำรวยที่จะมามอบโชครวยให้ท่านสมาชิก',
        video: 'https://s3.ap-southeast-1.amazonaws.com/asset.betflix8k.com/Copy+of+%E0%B8%8A%E0%B8%99%E0%B8%B0%E0%B8%A3%E0%B8%B2%E0%B8%87%E0%B8%A7%E0%B8%B1%E0%B8%A5+CaiShen+-+Google+Chrome+2564-07-16+16-28-35.mp4',
        title: 'Caishen Wins',
        studio: 'pg slot',
        imagePath: '/games/ironbank.jpg',
      },
      pokdeng: {
        text: 'POKDENG เกมไพ่ป๊อกเด้ง เกมสุดฮอตฮิตของไทย เป็นพนันที่ได้รับความนิยมเป็นอย่างมาก และยาวนานตลอดมา ป๊อกเด้งเป็นเกมที่สามารถเล่นได้หลายคน เป็นเกมส์แบบP2P คือเจอกับผู้เล่นอื่นเอง ไม่มีคอมเป็นตัวกลาง จบเกมได้ไว ชนะได้อย่างรวดเร็ว แถมมีรางวัลคูณเพิ่มด้วย',
        video: 'https://s3.ap-southeast-1.amazonaws.com/asset.betflix8k.com/Copy+of+Pokdeng+-+Google+Chrome+2564-07-16+16-22-54.mp4',
        title: 'POKDENG',
        studio: 'amb',
        imagePath: '/games/pokdeng.jpg',
      },
    };
    this.topgameDisplay = contents[value];
  }

  @Watch('topgameDisplay')
  // eslint-disable-next-line class-methods-use-this
  onTopGameDisplayChange(value: any) {
    const videoElement: HTMLVideoElement = (document.getElementById('topgame-video') as HTMLVideoElement);
    if (videoElement && this.$vuetify.breakpoint.lgAndUp) {
      videoElement.pause();
      videoElement.removeAttribute('src');
      videoElement.src = value.video;
      videoElement.load();
      videoElement.play();
      videoElement.muted = false;
    }
  }

  created() {
    this.$store.dispatch('Dialog/updateDialog', { open: true, dialogType: 'NotifyPromotionDialog' }, { root: true });
    this.displayItemDetail('moneytrain2');
  }
}
